import { RootState } from "@app/lib/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  selectedHistoryPropertyData: {},
};

export const propertyHistorySlice = createSlice({
  name: "propertyHistory",
  initialState,
  reducers: {
    setSelectedHistoryPropertyData: (state, action: PayloadAction<any>) => {
      state.selectedHistoryPropertyData = action.payload;
    },
  },
});

export const { setSelectedHistoryPropertyData } = propertyHistorySlice.actions;

export const getSelectedHistoryPropertyData = (state: RootState) =>
  state.propertyHistory.selectedHistoryPropertyData;

export default propertyHistorySlice.reducer;
